export const DOMAIN_URL = require('Config').protocol + require('Config').domain;

export const USER_SERVICE = {
	AUTHENTICATE: '/ws/G1R0C0/master-key-system/authenticate',
	PING: '/ws/G1R0C0/user/ping',
	LOGOUT: '/ws/G1R0C0/user/logout',
	SUBSCRIBE: '/ws/G1R0C0/user/subscribe'
};

export const MKS_SERVICE = {
	PING: '/ws/G1R0C0/master-key-system/ping',
	GET_PROJECTS: '/ws/G1R0C0/master-key-system/get-projects',
	GET_PROJECT: '/ws/G1R0C0/master-key-system/get-project',
	SAVE_PROJECT: '/ws/G1R0C0/master-key-system/save-project',
	DELETE_PROJECT: '/ws/G1R0C0/master-key-system/delete-project',
	DISABLE_PROJECT: '/ws/G1R0C0/master-key-system/disable-project',

	CLONE_PROJECT_TEMPLATE:
		'/ws/G1R0C0/master-key-system/clone-project-template',

	GET_LOCKINGS: '/ws/G1R0C0/master-key-system/get-lockings',
	GET_CYLINDER_TYPES: '/ws/G1R0C0/master-key-system/get-cylinders-types',
	SAVE_LOCKING: '/ws/G1R0C0/master-key-system/save-locking',
	CLONE_LOCKING: '/ws/G1R0C0/master-key-system/clone-locking',
	DELETE_LOCKING: '/ws/G1R0C0/master-key-system/delete-locking',
	GET_ROLES: '/ws/G1R0C0/master-key-system/get-roles',
	SAVE_ROLE: '/ws/G1R0C0/master-key-system/save-role',
	DELETE_ROLE: '/ws/G1R0C0/master-key-system/delete-role',
	CHANGE_RANGE_ROLES: '/ws/G1R0C0/master-key-system/change-range-roles',
	ADD_RIGHTS: '/ws/G1R0C0/master-key-system/add-rights',
	DELETE_RIGHTS: '/ws/G1R0C0/master-key-system/delete-rights',
	GET_PROJECT_EXCEL: '/ws/G1R0C0/master-key-system/get-project-excel',
	GET_OFFER: '/ws/G1R0C0/master-key-system/get-offer',
	GET_QUOTATION: '/ws/G1R0C0/master-key-system/get-quotation',
	CONTACT_US: '/ws/G1R0C0/master-key-system/contact-us',
	SUBSCRIBE: '/ws/G1R0C0/master-key-system/subscribe',
	DUPLICATE_PATTERN: '/ws/G1R0C0/master-key-system/duplicate-pattern'
};

export const EMPLOYEE_SERVICE = {
	GET_INTERLOCUTORS_BY_CUSTOMER:
		'/ws/G1R0C0/employee/get-interlocutors-by-customer',
	SET_INTERLOCUTOR: '/ws/G1R0C0/employee/set-interlocutor',
	PING: '/ws/G1R0C0/employee/ping',
	UNSET_INTERLOCUTOR: '/ws/G1R0C0/employee/unset-interlocutor'
};



// WEBPACK FOOTER //
// ./src/js/webAPI/configURL.js